import React, { ReactElement, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";

import { clearGameLink, setIFrameState } from "redux/games/gamesSlice";
import FontAwesomeIcon from "../FontAwesomeIcon";
import { useWindowSize } from "services/utils";
import styles from "./styles.module.scss"

export default function GameDialog(): ReactElement {
  const [width] = useWindowSize()
  const dispatch = useAppDispatch()
  const iFrameState = useAppSelector(state => state.games.iFrameState)
  const game = useAppSelector(state => state.games.game)
  const [isFullscreen, setIsFullscreen] = useState<boolean>()
  const [link, setLink] = useState<any>()

  const handleClose = () => {
    dispatch(setIFrameState(false))
    dispatch(clearGameLink())
  }

  const handleScreenMode = (value: boolean) => {
    setIsFullscreen(value)
  }

  useEffect(() => {
    if (game && game.content) {
      if (game.type === "link") {
        setLink(game?.content)
      } else {
        const winUrl = URL.createObjectURL(
          new Blob([game?.content], { type: "text/html" })
        );
        setLink(winUrl)
      }
    }

  }, [game])


  return (
    <Dialog
      open={iFrameState}
      fullScreen={
        game?.size === "full"
          || (game?.size !== "full" && isFullscreen)
          || width <= 1250 ?
          true :
          false
      }
      className={styles.gameDialog}
      PaperProps={{ className: styles.paper }}
    >
      <DialogTitle className={styles.dialogTitleContainer}>
        <Typography className={styles.gameLabel}>{game?.name}</Typography>
        <Box className={styles.buttonContainer}>
          {game?.size !== "full" &&
            <Box
              onClick={() => handleScreenMode(!isFullscreen ? true : false)}
              className={styles.screenModeButton}
            >
              <FontAwesomeIcon
                name={isFullscreen ? "arrows-minimize" : "arrows-maximize"}
                type="fas"
              />
            </Box>
          }
          <Box onClick={() => handleClose()} className={styles.closeIcon}>
            <FontAwesomeIcon name="xmark" type="fas" />
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent
        style={
          isFullscreen ? { width: "100%", height: "100%" } :
            game?.size !== "full" || width > 1250 ? {
              width: Number(game?.size.split(",")[0]),
              height: Number(game?.size.split(",")[1])
            } : {}
        }
        className={styles.dialogContent}
      >
        <iframe
          src={link}
          height={"100%"}
          width={"100%"}
          className={styles.iframe}
        />
      </DialogContent>
    </Dialog >
  )
}